/**
 * Fonctions de validation réutilisables pour tous les composants
 */

/**
 * Valide une adresse email complète
 * @param {string} email - L'email à valider
 * @param {string} fieldName - Le nom du champ pour les messages d'erreur
 * @returns {Object} { valid: boolean, message: string }
 */

export function validateEmail(email, fieldName = "email") {

    console.log('dans validateEmail function:');

    const emailTrimmed = email
                            .trim()
                            .normalize("NFKC")
                            .replace(/\u200B/g, ""); // supprime zero-width spaces

    const forbiddenChars = ['/', '\\', ',', ';', ' ', '"', "'", '<', '>', '*'];
    let foundForbiddenChar = forbiddenChars.find(char => emailTrimmed.includes(char));

    if (foundForbiddenChar) {
        return {
            valid: false,
            message: `Le champ "${fieldName}" ne doit pas contenir le caractère "${foundForbiddenChar}".`
        };
    }
    
    if (emailTrimmed.endsWith('.') || emailTrimmed.endsWith(',') || emailTrimmed.endsWith(';')) {
        return {
            valid: false,
            message: `Le champ "${fieldName}" ne doit pas se terminer par un point, une virgule ou un point-virgule.`
        };
    }
    
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(emailTrimmed)) {
        return {
            valid: false,
            message: `Le champ "${fieldName}" doit être une adresse email valide.`
        };
    }
    
    if (emailTrimmed.includes("..")) {
        return {
            valid: false,
            message: `Le champ "${fieldName}" ne doit pas contenir de points consécutifs.`
        };
    }
    
    const parts = emailTrimmed.split("@");
    if (parts.length !== 2) {
        return {
            valid: false,
            message: `Le champ "${fieldName}" doit contenir un seul @.`
        };
    }
    
    const [localPart, domainPart] = parts;
    
    if (!localPart || localPart.length === 0) {
        return {
            valid: false,
            message: `Le champ "${fieldName}" doit avoir un nom avant le @.`
        };
    }
    
    if (localPart.startsWith(".") || localPart.endsWith(".")) {
        return {
            valid: false,
            message: `Le champ "${fieldName}" ne doit pas commencer ou finir par un point avant le @.`
        };
    }
    
    if (!domainPart || !domainPart.includes(".")) {
        return {
            valid: false,
            message: `Le champ "${fieldName}" doit avoir un domaine valide (ex: example.com).`
        };
    }
    
    if (domainPart.startsWith(".") || domainPart.endsWith(".")) {
        return {
            valid: false,
            message: `Le domaine du champ "${fieldName}" ne doit pas commencer ou finir par un point.`
        };
    }
    
    const domainParts = domainPart.split(".");
    const extension = domainParts[domainParts.length - 1];
    
    if (!extension || extension.length < 2) {
        return {
            valid: false,
            message: `Le champ "${fieldName}" doit avoir une extension valide (ex: .com, .fr, .org).`
        };
    }
    
    if (!/^[a-zA-Z]{2,}$/.test(extension)) {
        return {
            valid: false,
            message: `L'extension du champ "${fieldName}" doit contenir uniquement des lettres (minimum 2).`
        };
    }
    
    for (let i = 0; i < domainParts.length; i++) {
        const part = domainParts[i];
        if (!part || part.length === 0) {
            return {
                valid: false,
                message: `Le domaine du champ "${fieldName}" contient des segments vides.`
            };
        }
        
        // Vérifier que chaque partie ne contient que des lettres, chiffres et tirets
        if (!/^[\p{L}0-9-]+$/u.test(part)) {
            return {
                valid: false,
                message: `Le domaine du champ "${fieldName}" contient des caractères invalides.`
            };
        }
        
        if (part.startsWith("-") || part.endsWith("-")) {
            return {
                valid: false,
                message: `Le domaine du champ "${fieldName}" ne doit pas avoir de tirets au début ou à la fin.`
            };
        }
    }
    
    return { valid: true };
}

/**
 * Valide un numéro de téléphone
 * @param {string} phone - Le numéro de téléphone à valider
 * @param {string} fieldName - Le nom du champ pour les messages d'erreur
 * @returns {Object} { valid: boolean, message: string }
 */
export function validatePhone(phone, fieldName = "téléphone") {
    const phoneTrimmed = phone.trim();
    const phoneClean = phoneTrimmed.replace(/\./g, '');
    if (phoneClean.length !== 10) {
        return {
            valid: false,
            message: `Le champ "${fieldName}" doit contenir exactement 10 chiffres. Vous avez saisi ${phoneClean.length} chiffre(s).`
        };
    }
    //commence tjrs par 0
    const phoneRegex = /^0[1-9][0-9]{8}$/;
    
    if (!phoneRegex.test(phoneClean)) {
        return {
            valid: false,
            message: `Le champ "${fieldName}" doit être un numéro de téléphone valide commençant par 0 (ex: 0612345678).`
        };
    }
    return { valid: true };
}


export default {
    validateEmail,
    validatePhone,
};